module.exports = __webpack_public_path__ + "img/close_icon.d22ae2c8.svg";